import axios from 'axios';

export default {
  reloadBuilds({ commit, state }) {
    return new Promise((resolve, reject) => {
      commit('reloadBuildsRequestPending');
      axios({
        url: `${state.appConfig.backendUrl}/v1/admin/build/reload`,
        method: 'GET'
      })
        .then(resp => {
          if (resp?.data?.result !== true) {
            commit('reloadBuildsRequestError');
            reject(new Error());
            return;
          }
          commit('reloadBuildsRequestSuccess');
          resolve(resp);
        })
        .catch(err => {
          commit('reloadBuildsRequestError', err);
          reject(err);
        });
    });
  },

  reloadBuildsForWl({ commit, state }, { whitelabelId }) {
    return new Promise((resolve, reject) => {
      commit('reloadBuildsRequestPending');
      axios({
        url: `${state.appConfig.backendUrl}/v1/admin/build/reloadForWl`,
        method: 'GET',
        params: { whitelabelId }
      })
        .then(resp => {
          if (resp?.data?.result !== true) {
            commit('reloadBuildsRequestError');
            reject(new Error());
            return;
          }
          commit('reloadBuildsRequestSuccess');
          resolve(resp);
        })
        .catch(err => {
          commit('reloadBuildsRequestError', err);
          reject(err);
        });
    });
  },

  updateBuildsStatuses({ commit, state }) {
    return new Promise((resolve, reject) => {
      commit('updateBuildsStatusesRequestPending');
      axios({
        url: `${state.appConfig.backendUrl}/v1/admin/build/update`,
        method: 'GET'
      })
        .then(resp => {
          if (resp?.data?.result !== true) {
            commit('reloadBuildsRequestError');
            reject(new Error());
            return;
          }
          commit('updateBuildsStatusesRequestSuccess');
          resolve(resp);
        })
        .catch(err => {
          commit('updateBuildsStatusesRequestError', err);
          reject(err);
        });
    });
  },
  getBuilds({ commit, state }, { ctx, filter }) {
    return new Promise((resolve, reject) => {
      axios({
        url: `${state.appConfig.backendUrl}/v1/admin/build/get`,
        params: { ...ctx, ...filter },
        method: 'GET'
      })
        .then(resp => {
          if (resp?.data?.result !== true) {
            reject(new Error());
            return;
          }
          commit('insertBuilds', resp.data);
          resolve(resp);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  deleteBuild({ commit, state }, buildId) {
    return new Promise((resolve, reject) => {
      commit('deleteBuildRequestPending');
      axios({
        url: `${state.appConfig.backendUrl}/v1/admin/build/destroy`,
        params: { id: buildId },
        method: 'DELETE'
      })
        .then(resp => {
          if (resp?.data?.result !== true) {
            reject(new Error());
            return;
          }
          commit('deleteBuildRequestSuccess');
          resolve(resp);
        })
        .catch(err => {
          commit('deleteBuildRequestError', err);
          reject(err);
        });
    });
  },
  deleteAllBuilds({ commit, state }) {
    return new Promise((resolve, reject) => {
      commit('deleteAllBuildsRequestPending');
      axios({
        url: `${state.appConfig.backendUrl}/v1/admin/build/destroyAll`,
        method: 'DELETE'
      })
        .then(resp => {
          if (resp?.data?.result !== true) {
            reject(new Error());
            return;
          }
          commit('deleteAllBuildsRequestSuccess');
          resolve(resp);
        })
        .catch(err => {
          commit('deleteAllBuildsRequestError', err);
          reject(err);
        });
    });
  },
  deleteBuildsByFilter({ commit, state }, params) {
    return new Promise((resolve, reject) => {
      commit('deleteBuildsByFilterRequestPending');
      axios({
        url: `${state.appConfig.backendUrl}/v1/admin/build/destroyByFilter`,
        params,
        method: 'DELETE'
      })
        .then(resp => {
          if (resp?.data?.result !== true) {
            reject(new Error());
            return;
          }
          commit('deleteBuildsByFilterRequestSuccess');
          resolve(resp);
        })
        .catch(err => {
          commit('deleteBuildsByFilterRequestError', err);
          reject(err);
        });
    });
  }
};
